import { render, staticRenderFns } from "./SearchClient.vue?vue&type=template&id=ef365a94&scoped=true&lang=pug&"
import script from "./SearchClient.vue?vue&type=script&lang=ts&"
export * from "./SearchClient.vue?vue&type=script&lang=ts&"
import style0 from "./SearchClient.vue?vue&type=style&index=0&id=ef365a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef365a94",
  null
  
)

export default component.exports